import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { TabButton } from './styles';

type TabType = 'exceptions' | 'schedules';

interface AutomationTabsProps {
  active: 'exceptions' | 'schedules';
  onClickTab: (tab: TabType) => void;
  fixed?: boolean;
}

export function AutomationTabs({
  active,
  fixed,
  onClickTab,
}: Readonly<AutomationTabsProps>): ReactElement {
  const { t } = useTranslation();
  const showExceptions = active === 'exceptions';

  return (
    <>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '150px 6px 150px auto',
          height: '5px',
          marginTop: '24px',
        }}
      >
        <span
          style={{
            borderTop: '1px solid lightgrey',
            borderRight: '1px solid lightgrey',
            borderRadius: '6px 6px 0 0',
            backgroundColor: showExceptions ? '#f4f4f4' : 'transparent',
          }}
        />
        <span />
        <span
          style={{
            border: '1px solid lightgrey',
            borderBottom: 'none',
            borderRadius: '6px 6px 0 0',
            backgroundColor: showExceptions ? 'transparent' : '#f4f4f4',
          }}
        />
        <span />
      </div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: '150px 6px 150px auto',
      }}
      >
        <TabButton
          activeTab={active === 'schedules'}
          onClick={() => onClickTab('schedules')}
        >
          {t('programacoes')}
        </TabButton>
        <span
          style={{
            borderBottom: '1px solid lightgrey',
          }}
        />
        <TabButton
          activeTab={active === 'exceptions'}
          onClick={() => onClickTab('exceptions')}
        >
          {t('excecoes')}
        </TabButton>
        <span
          style={{
            borderBottom: '1px solid lightgrey',
            marginRight: fixed ? '6px' : undefined,
          }}
        />
      </div>
    </>
  );
}
